import { ref, computed } from 'vue';
import type { DataTableSortMeta } from 'primevue/datatable';

/**
 * Tracks the active multi-sort state of a DataTable.
 * Bind `multiSortMeta` with `v-model:multiSortMeta` and apply
 * `sortBadgeClass` as a class on the DataTable to hide the sort-order
 * badge when only a single column is sorted.
 */
export function useDataTableMultiSort() {
  const multiSortMeta = ref<DataTableSortMeta[]>([]);
  const sortBadgeClass = computed(() =>
    multiSortMeta.value.length <= 1 ? 'single-sort' : undefined
  );
  return { multiSortMeta, sortBadgeClass };
}
